import React from 'react';
import 'twin.macro';

import Heading from '~components/Heading';

interface HeroProps {
  title: string;
}

const Hero: React.FC<HeroProps> = ({ title, children }) => (
  <div tw="relative pt-96 pb-6 mb-12">
    <div tw="container relative z-20">
      <Heading level="h1" tw="max-w-5xl bg-gray-900 text-gray-50 py-4 px-6 rounded-lg border-b-8 border-blue">
        {title}
      </Heading>
    </div>
    {children}
  </div>
);

export default Hero;
